module.exports = __webpack_public_path__ + "officialStatic/img/logo3.97c9e99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo3.png
// module id = vdCK
// module chunks = 0